import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterChips = ({ filters, activeFilters, onFilterChange, onShowMoreFilters }) => {
  const visibleFilters = filters?.slice(0, 3);
  const hasMoreFilters = filters?.length > 3;

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-4 scrollbar-hide">
      {visibleFilters?.map((filter) => {
        const isActive = !!activeFilters?.[filter?.key];
        return (
          <div key={filter?.key} className="flex-shrink-0">
            <button
              onClick={() => onFilterChange(filter?.key, !isActive)}
              className={`whitespace-nowrap inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium border transition-colors ${
                isActive
                  ? 'bg-gray-900 text-white border-gray-900'
                  : 'bg-white text-gray-700 border-gray-200 hover:border-gray-300 hover:text-gray-900'
              }`}
            >
              {filter?.label}
              {isActive && <Icon name="X" size={13} />}
            </button>
          </div>
        );
      })}
      {hasMoreFilters && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onShowMoreFilters}
          iconName="SlidersHorizontal"
          iconPosition="left"
          className="flex-shrink-0 text-gray-700 hover:text-gray-900"
        >
          More Filters
        </Button>
      )}
    </div>
  );
};

export default FilterChips;